import * as Sentry from '@sentry/react'
import { api } from './api'
import { UserProfile } from '@/types/user-profile'

export const getUserProfile = async (): Promise<UserProfile> => {
  const user: UserProfile = await api.get(`/user/profile`)

  Sentry.setUser({
    id: user.userId,
    role: 'user',
  })

  return user
}

export const updateUser = (
  id: string,
  {
    name,
    surname,
    phone,
  }: { name: string; surname: string; phone: string | null },
): Promise<UserProfile> => {
  return api.put(`/user/${id}`, { name, surname, phone })
}

export const updateUserLanguage = (
  id: string,
  { language }: { language: string },
) => {
  return api.put(`/user/${id}`, { language })
}
